import { render, staticRenderFns } from "./EditDigitalForm.vue?vue&type=template&id=774aebb7&scoped=true&"
import script from "./EditDigitalForm.vue?vue&type=script&lang=js&"
export * from "./EditDigitalForm.vue?vue&type=script&lang=js&"
import style0 from "./EditDigitalForm.vue?vue&type=style&index=0&id=774aebb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774aebb7",
  null
  
)

export default component.exports